import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./en.js";
import ch from "./ch.js";

Vue.use(VueI18n);

const messages = {
  en: {
    language: {
      // 404页面
      notFoundMsg: "Page not found",
      // header & footer
      headerServices: "Services",
      headerServicesOur: "Products",
      headerServicesDelivery: "Cloud APP Delivery",
      headerServicesConnection: "Cloud Xpress Connect",
      headerServicesSd: "SD-WAN",
      headerServicesGlobal: "Global APP Access",
      headerSolutions: "Solutions",
      headerSolutionsOur: "Our Solutions",
      headerSolutionsSaas: "SaaS Acceleration",
      headerSolutionsCloud: " Private Cloud Service",
      headerSolutionsMpls: "MPLS Hybrid",
      headerSolutionGlobal: "Company OA/ERR platform acceleration ",
      headerAbout: "About US",
      aboutCompany: "About Company",
      aboutTeam: "Our Team",
      aboutInver: "Investor",
      headerLanguage: "中文",
      headerLog: "Login",
      footerHome: "Home",
      footerService: "service",
      footerTech: "Technical Support",
      footerAbout: "About us",
      footerBack: "Back to top",

      // 主页文字
      mainWhatWan: "What is SD-WAN",
      mainWhatWanDefined: "Software-Defined Network",
      mainWhatWanGlobal: "Global Deployment",
      mainWhatWanConnection: "Enterprise Network Connection",
      mainWhyWan: "Why choose OBC SD-WAN",
      mainWhyWanHeight: "High Performance Data Transmission",
      mainWhyWanStrong: "Strong Security",
      mainWhyWanFlexible: "Flexible Deployment",
      mainCloud: "Cloud APP Delivery",
      mainCloudSaas: "Global SaaS Acceleration",
      mainCloudApp: "Protecting Application Data",
      mainCloudSoho: "Flexible Deployment",
      mainCloudRemote: "Real-time and Comprehensive Monitor",
      mainCloudConnection: "Cloud Xpress Connect",
      mainCloud1: "Cloud Xpress Connect",
      mainGlobal: "Enterprise Global Special Network",
      mainData: "Enterprise Data Acceleration",
      mainSimple: "Simple Deployment",
      mainSafeData: "Secured Data Channel",
      mainCloudBranch: "Enterprise Global Special Network",
      mainCloudData: "Enterprise Data Acceleration",
      mainCloudSecured: "Secured Data Channel",
      mainCloudEasy: "Simple Deployment",
      mainFeatures: "Our Features",
      mainFeaturesWe: "We are a pioneer of SD-WAN service solution provider",
      mainFeaturesBuild:
        "We build advanced, stable, high speed, low latency WAN networks to help enterprise users focus on their core business",
      mainPERFORMANCE: "High Performance",
      mainPERFORMANCEDetail:
        "With our FastIP technology, a high bandwidth network will be built between different locations",
      mainSECURITY: "Strong Security",
      mainRELIABILITYDetail:
        "High-intensity data encryption technology will ensure privacy during data transmission",
      mainRELIABILITY: "High Reliability",
      mainSECURITYDetail: "High availability guarantee with 7*24 service",
      mainSMART: "Smart Routing",
      mainSMARTDetail:
        "An auto-recovered network with decentralized artificial intelligence controller",
      mainEASY: "Easy to Use",
      mainEASYDetail: "A human friendly management websit for operator",
      mainREAL: "Real-time Monitoring",
      mainREALDetail:
        "Monitoring status each second, and raise alarm when problems found",
      mainANALYTICS: "Data Analysis",
      mainANALYTICSDetail:
        "Dash board with varieties of data, reports and statistics for analysis",
      mainFlexible: "Flexible Deployment",
      mainFlexibleDetail:
        "The OBC solutions can be deployed wherever there is Internet access.",
      mainGlobalEnterprise:
        "Global Enterprise Network with OBC Cloud Connection as a Service",
      mainGlobalWith:
        "It is efficient to set up a private Global Network Connectivity by OBC Cloud Xpress Connect Service.",
      mainGlobalImprove:
        "Improve Application Performance by OBC Cloud APP Delivery Service",
      mainGlobalSaas:
        "Enterprise cloud SaaS application (Office 365, Salesforce, SAP…) performance will accelerate at least 4 times with OBC Cloud Delivery Service.",
      mainWorldwide: "Globally Distributed SD-WAN Nodes",
      mainSmart: " Intelligent routing enables high availability",
      mainShowMore: "Expand to learn more",
      mainClickShowMore: "Click to learn more",

      // 服务
      serviceOur: "Our Products",
      serviceWe: "Learn more about the products we offer.",
      serviceCloud: "Cloud App Delivery",
      serviceSingle: "Flexible single-point deployment",
      serviceAcce: "Multiple SaaS application acceleration",
      serviceSingleEnd: "Specific country/regional site access acceleration",
      serviceUnderstand1: "Learn More",
      serviceConnectAs: "Cloud Xpress Connect",
      serviceDouble: "Point-to-point or multipoint-to-multipoint deployment",
      serviceBuild: "Build a global private network through OBC core network",
      serviceConnectCustomer:
        "Connect customer’s headquarters and offices across the globe",
      serviceOBC: "OBC SD-WAN Solutions",
      serviceHigh: "High performance",
      serviceStrong: "Strong security",
      serviceFlex: "Flexible deployment",
      serviceGlobalApp: "Global APP Access",
      serviceQuickly: "Quick distribution aimed content worldwide",
      serviceCustomer:
        "The Internet access will automatically select the closest OBC Cloud Node through our AI DNS transalation.",
      serviceSupports:
        "Support distributed deployment for both static resources and dynamic data",

      // 云快递
      deliveryCloud: "Cloud APP Delivery",
      deliveryAccApp:
        "Accelerate all Public Cloud applications such as Ali Mail, Office 365, Salesforce, etc.",
      deliveryAccVM:
        "Accelerate all Public Cloud VMs such as Ali Yun ECS, Amazon AWS, Microsoft Azure, etc.",
      deliveryAccService:
        "Accelerate Internet services for specific country or region.",
      deliveryProblem: "We privode the solutions of these problems",
      deliveryHighNet:
        "High latency when accessing the network in specific country/region",
      deliveryLowNet1:
        "Low network speed when accessing headquarter data Centre from branches",
      deliveryLowNet2: "Low network speed when accessing Public Cloud APP",
      deliveryAccNet: "Accelerate network speed in cross-region scenario",
      deliveryAccAll: "Accelerate all Public Cloud applications",

      // 云快线
      connectionService: "Cloud Xpress Connect",
      connectionInternet: "Internet",
      connectionOBC: "OBC Overlay Cloud connection",
      connectionProvide:
        "Provide OBC overlay cloud connection between edge connectors",
      connectionHeadquarter:
        "Cloud connection between headquarter and Private Cloud nodes",
      connectionBranches:
        "Cloud connection between branches and Public Cloud nodes",
      connectionHeadquarterBranches:
        "Cloud connection between headquarter and branches",
      connectionAchieve:
        "Achieve high-speed and low-latency transmission layer multinational connections",
      connectionPrivate:
        "WAN connection between headquarter and Private Cloud nodes",
      connectionPublic:
        "WAN connection between branches and Public Cloud nodes",
      connectionHead: "WAN connection between headquarter and branches",

      // SD
      SDWhat: "Why OBC SD-WAN",
      SDWith:
        "With the enterprise broadband access and Internet backbone network capacity increasing, SD-WAN provides a low-cost network solution based on existing circuits.",
      SDTradition: "Traditional MPLS Private Network",
      SDInTradition:
        "For traditional enterprise, applications like email, file-sharing, OA are centralize deployed. The traditional private or MPLS circuit has many limitations: complex deployment, expensive CAPEX/OPEX, and lack of flexibility.",
      SDLimitations:
        "Typically, branch offices that locates in different countries connect to headquarter's data center through the private or MPLS circuit, the architecture is shown below:",
      SDThen: "All these limitations can be overcome by SD-WAN solution",
      SDSDWan: "SD-WAN",
      SDEmploy:
        "SD-WAN employs the control/date plane segregation, centralized management and other SDN conceptions. It helps company to fast deploy WAN network across the world with an easy operation center.",
      SDDoyou: "Do you have or are you planning to deploy SD-WAN?",
      SDPER1: "We currently have an SD-WAN deployment",
      SDPER2: "We are considering SD-WANs",
      SDPER3: "We don't know SD-WAN",
      SDPER4: "We're deploying other WAN network",
      SDPER5: "We are actively planning for an SD-WAN",
      SDPER52: "deployment in the next 12 months",
      SDWhy: "Why OBC SD-WAN?",
      SDWeBuild:
        "We build advanced, stable, high speed, low latency WAN network to help enterprise users focus on their core business.",
      SDPlug: "Plug & Play",
      SDPlug1: "Edge connector with Plug & Play solutions",
      SDPlug2:
        "All the configuration is completed by the OBC cloud controller without any on-site integration",
      SDPlug3: "",
      SDAgile: "Agile & Lean Deploment",
      SDAgile1: "Fast deployment of Agile & Lean",
      SDAgile2: "Zero IT knowledge requirement for customer side.",
      SDAgile3:
        "Support Lay 2/3 connection, no modification to customer’s current network topology.",
      SDGlobal: "Global Coverage",
      SDGlobal1:
        "The OBC solutions can be deployed wherever there is Internet access",
      SDOnDemand: "On-Demand Paid with Opex Mode",
      SDOnDemand1: "Cost-efficient for customers",
      SDOnDemand2: "Hardware and software free of charge",
      SDOnDemand3: "The customer only need to pay for subscription fee.",
      SDSecure: "Secure Data Channel",
      SDSecure1:
        "AES256 encryption is deployed by OBC to ensure the security the customer's data in the transmission process.",
      SDHardware: "Hardware Lifetime Warranty",
      SDHardware1:
        "OBC commits to offer 99.9% availability and free replacement for all hardware",
      SDHardware2: "",

      // 全球应用加速
      serviceGlobalBased:
        "Based on OBC global distribution Cloud Nodes, your website content will be fasten published to any country or region globaly, hence it will fasten the access speed to your required website.",
      serviceGlobalSupporting:
        "Supporting the speed acceleration for both static resources and dynamic data interfaces at the same time, which is much better than the normal CDN performance.",
      serviceGlobalInternet:
        "Internet speed can be increased hundredfold while using OBC service in cross-country network visiting",
      serviceGlobalHaundredfold: "Hundredfold growth",
      serviceGlobalEffect: "Effect example",
      serviceGlobalUSA: "USA",
      serviceGlobalUSAspeed1: "Internet speed before boost: 40 K/S",
      serviceGlobalUSAspeed2: "Internet speed after boost: 13 M/S",
      serviceGlobalJapan: "Japan",
      serviceGlobalJapanspeed1: "Internet speed before boost: 50 K/S",
      serviceGlobalJapanspeed2: "Internet speed after boost: 20 M/S",
      serviceGlobalIndia: "India",
      serviceGlobalIndiaspeed1: "Internet speed before boost: 20 K/S",
      serviceGlobalIndiaspeed2: "Internet speed after boost: 17 M/S",

      // 解决方案
      solutionOur: "Our Solutions",
      solutionOBC:
        "OBC SD-WAN provides several professional solutions for enterprise network connection",
      solutionOffice:
        "Office 365 performance improvement with OBC Cloud APP Delivery solution",
      solutionGlobal:
        "Global private network with OBC Cloud Xpress Connect solution",
      solutionMPLS: "MPLS to OBC hybrid WAN evolution",
      solutionGlobalApp:
        "Global Application Deployment for enterprise OA/ERP platform acceleration",

      // 解决方案1
      solution1Office:
        "Office 365 performance improvement with  OBC Cloud APP Delivery solution",
      solution1Cloud:
        "OBC Cloud APP Delivery can offer smooth interaction of Office 365 cloud application with low-cost network connection. The network architecture of deployment is shown below :",
      solution1Application:
        "Application experience improvement with OBC Cloud APP Delivery",
      solution1Edge1:
        "OBC edge connector is deployed at each branch office, which connects the OBC cloud delivery network. And OBC’s cloud delivery network accelerates the data transmission to the Office 365’s cloud server.",
      solution1Edge2:
        "OBC Cloud APP Delivery solution makes a significant improvement of application experience with low latency network technology.",

      // 解决方案2
      solution2Global:
        "Global Private Network with OBC Cloud Xpress Connect Solution",
      solution2OBCConnection:
        "OBC Cloud Xpress Connect solution makes a fast and easy way to construct a global private network.",
      solution2OBCNetwork: "The network deployment topology is shown below :",
      solution2OBCCloud:
        "OBC Cloud Xpress Connection employs the AES-256 strong encryption to protect user data transmission worldwide, and the FastIP acceleration technology significantly improves the communication performance.",
      solution2OBCSDWAN:
        "By the deployment of OBC SD-WAN cloud connection, the branch offices located in different places can visit each other with virtual L2 or L3 network.",
      solution2With:
        "  The OPEX and CAPEX will be significantly lower than MPLS by OBC Cloud Xpress Connect",
      solution2Bandwidth: "Bandwidth Cost",

      // 解决方案3
      solution3MPLS: "MPLS to OBC Hybrid WAN Evolution",
      solution3Connection:
        "OBC Cloud Xpress Connect solution makes a fast and easy way to construct a global private network.",
      solution3Network: "The network deployment topology is shown below :",
      solution3AsAbove:
        "As the image shown above, OBC edge connector hybrids the MPLS and Internet connection together.Once the MPLS breaks down, the OBC edge switch the data to the Internet link, and the MPLS link will be monitored until it recovers.",
      solution3TheMpls:
        "The MPLS link works in the active state in normal case, and the Internet link keep in backup state.",
      solution3Once:
        "Once the MPLS breaks down, the OBC edge switch the data to the Internet links. And the MPLS link will be kept monitored until it recovers.",
      solution3ImageShow:
        "The image above shows the hybrid link fail-over case.",

      // 解决方案4
      solution4Using:
        "Using Global Application Deployment to Accelerate Enterprise OA/ERP Platforms",
      solution4Enterprise:
        "Once enterprise OA/ERP platforms are connected to OBC Global Application Deployment, the enterprise data resources will be quickly accessed throughout the world.",
      solution4Noneed:
        "No need to deploy any hardware devices, global employees can visit the domain provided by OBC global application deployment to achieve full acceleration of static resources and dynamic data.",
      solution4Application: "Application Overview",
      solution4Before:
        "Before acceleration : 10-20Kbps, After acceleration : 10-20Mbps",

      // 关于我们
      aboutOcean: "OCEANBLUE CLOUD",
      aboutMake: "Make Connection Easy, Make Business Agile",
      aboutWhoWeAre: "Who We Are",
      aboutAboutUs: "About Us",
      aboutWeAre: "We are OceanBlue Cloud, a leading SD-WAN provider.",
      aboutFor:
        "For decades, companies rely on WAN technologies (e.g. DDN, Frame Relay and MPLS) to transfer business data with high quality. Today, as cloud strucutre and hybrid structure are widely used, and demand for big data and real-time data transmission increases, traditional WAN technology is no longer able to satisfy enterprise customers, who increasingly demand faster responses and more reliable connections.",
      aboutOceanBlue:
        " Oceanblue Cloud(ShenZhen Ruiwang Yunlian Technology Co.,Ltd.) reckons that long-distance and high-quality real time data transmission should not be the bottleneck of business development. As such, we relied on our state-of-the-art 'Fastip' technology to help enterprise customers connect to WAN at a faster speed.",
      aboutWithOur:
        " With our service, customers are able to enjoy ultra-high speed, high quality data transmission service through the Internet or MPLS. In addition, OBC leverages the artificial intelligence technology to redefine the WAN by optimizing network traffic and conducting real-time network health check using distributed cloud control system, which increases the visibility of SLA.",
      aboutTianCheng: "Tiancheng Zhang",
      aboutFounder: "Founder & CEO",
      aboutTianChengExperience:
        "15+ years in ICT industry, CCIE, System Analyst. He has worked as senior positions in Ericsson / Huawei / Emirates Telecom and other top companies. He has deep understanding in enterprise and telecom field with excellent execution and willpower.",
      aboutYaoHua: "Yaohua Liu",
      aboutCo1: "Co-Founder",
      aboutYaoHuaExperience:
        "15+ years of experience in R&D, Senior architect, he had worked in Ericsson / Samsung / Nortel. He has a profound understanding in the distributed system and wealth of experience with product life-cycle management quality Control.",
      aboutLei: "Larry Wang",
      aboutCo2: "Co-Founder",
      aboutLeiExperience:
        "10+ years in the bottom layer of network technology development, He has a deep understanding network development technology. He has excellent understanding of the whole process from development to application.",
      aboutLocations: "Locations",
      aboutSZ: "Shenzhen, China",
      aboutSZemail: "contact@oceanbluecloud.com",
      aboutSZaddr1:
        "Room 601, Building A, Building E2, TCL International E City, Xili Street, Nanshan District, Shenzhen City, Guangdong Province",
      aboutHK: "Hongkong, China",
      aboutHKemail: "contact@oceanbluecloud.com",
      aboutHKaddr1:
        "Unit 15B, Gaoming Commercial Building 998 Canton Road, Mong Kok, HongKong",
      aboutDubai: "Dubai, U.A.E",
      aboutDubaiEmail: "contact@oceanbluecloud.com",
      aboutDubaiAddr1:
        "Unit No 68, Ground floor, Bldg. No.17 Dubai Internet City, Dubai UAE PO BOX 336810",
      aboutSingapore: "Singapore",
      aboutSingaporeEmail: "contact@oceanbluecloud.com",
      aboutSingaporeAddr1: "#10-09 PAYA LEBAR SQUARE SINGAPORE,",
      aboutSingaporeAddr2: "",
      aboutSingaporeAddr3: "+0065 92343288",
      aboutSingaporeAddr4: "",

      aboutSuzhou: "Suzhou, China",
      aboutSuzhouEmail: "contact@oceanbluecloud.com",
      aboutSuzhouAddr1:
        "Xinping Street No. 388, Ascendas iHub, Building 21, 5th Floor, Room 04.",
      aboutSuzhouAddr2: "",
      aboutSuzhouAddr3: "Tel: 0512-88982707",
      aboutSuzhouAddr4: "",

      aboutShanghai: "Shanghai, China",
      aboutShanghaiEmail: "contact@oceanbluecloud.com",
      aboutShanghaiAddr1:
        "Room 813, Building T2, Jingyao Qiantan, No. 308 Yaoti Road, Pudong New District, Shanghai",
      aboutShanghaiAddr2: "",
      aboutShanghaiAddr3: "Tel: 021-31836988",
      aboutShanghaiAddr4: "",

      aboutJiNan: "JiNan, China",
      aboutJiNanEmail: "contact@oceanbluecloud.com",
      aboutJiNanAddr1:
        "Room 802, Tower D, CBD Central Plaza 6-17 Jiefang East Road Jinan City, ShanDong Province",
      aboutJiNanAddr2: "",
      aboutJiNanAddr3: "",
      aboutJiNanAddr4: "",

      aboutUSA: "CA · USA",
      aboutUSAEmail: "contact@oceanbluecloud.com",
      aboutUSAAddr1:
        "1360 Valley Vista Dr, Suite 125, Diamond Bar, CA 91765, USA",
      aboutUSAAddr2: "",
      aboutUSAAddr3: "",
      aboutUSAAddr4: "",

      aboutFlb: "Philippines",
      aboutFlbEmail: "contact@oceanbluecloud.com",
      aboutFlbAddr1:
        "18th Floor, ORE Central, 31st Street, Taguig, Metro Manila, Philippines",
      aboutFlbAddr2: "",
      aboutFlbAddr3: "",
      aboutFlbAddr4: "",

      aboutBJ: "BeiJing · China",
      aboutBJEmail: "contact@oceanbluecloud.com",
      aboutBJAddr1:
        "Room 708, Chaowai MENB Building, No. 26 Chaowai Street, Chaoyang District, Beijing",
      aboutBJAddr2: "",
      aboutBJAddr3: "",
      aboutBJAddr4: "",

      aboutBX: "Brazil",
      aboutBXEmail: "contact@oceanbluecloud.com",
      aboutBXAddr1:
        "Av dos Autonomistas4900, galpão C 03.0.0, km 18, Osasco-SP Brasil CEP: 06194-060",
      aboutBXAddr2: "",
      aboutBXAddr3: "",
      aboutBXAddr4: "",

      serviceUs: "Contact Us",
      serviceEmail: "Email",
      serviceTime: "Service Time",
      serviceTime2: "Monday-Friday 09:30-18:30, except holidays",
      serviceTel: "Service　Hotline",
      serviceTime3: "Service Time",
      serviceWeChat: "Scan Code Subscribe WeChat Service Account",

      // 活动页
      yunQiComputingTitle: "The Computing Conference",
      yunQiComputingContent1:
        "The Computing Conference is a major worldwide event in the field of cloud computing. The conference covers all the latest trends in frontier technologies, including Cloud Computing, Big Data, and AI. The event in Hangzhou event is the largest one and the focal point of the conference, held in October 2017.",
      yunQiComputingContent2:
        'OceanBlue Cloud, a leading SD-WAN provider, leverages the artificial intelligence technology to redefine the WAN by optimizing network traffic and conducting real-time network health check using distributed cloud control system, which increases the visibility of SLA. We relied on our state-of-the-art "Fastip" technology to help enterprise customers connect to WAN at a faster speed.',
      yunQiDetailsTitle: "/ Details of the exhibition",
      yunQiDetailsDuring:
        "During the conference, we will show you our solutions and amazing services , You can experience it on the spot.",
      yunQiDetailsKeynote:
        "Keynote Speech:  Make business agile by deploying cloud based connection.",
      yunQiDetailsFounder: "2017-10-13   Founder&CEO -Alexann Zhang.",
      yunQiDetailsSome:
        "Some one-year service coupon will be sent during the conference.",
      yunQiDetailsMore:
        "More exciting content please continue to pay attention.",
      yunQiLocationTitle: "Oct.11-14, 2017",
      yunQiLocationContent:
        "Venue: D3-301,Yunqi Town International Exhibition Center, West Lake District He Shan Road, Hangzhou, China",
      yunQiExhibitionTitle: "Exhibition welfare",
      yunQiExhibitionContent1: "one-year free trial",
      yunQiExhibitionContent2: "To provide you with a service",
      yunQiExhibitionContent3: "experience",
      yunQiExhibitionContent4:
        "OBC is dedicated to optimizing the user's network experience.",
      yunQiExhibitionContent5:
        "During the conference, we have prepared our products and services for you to experience.The user who gets the coupon please click the bottom exchange button at the specified exchange date to complete the information to be used.",
      yunQiExhibitionOk: "Coupon activation",

      // 投资人
      investorTitle: "Our Investor",

      // 体验券
      yunQiOcean: "Oceanblue Cloud",
      yunQiOceanCreate: "Create a new style of intelligent network",
      couponTitle: "Free coupon activation",
      couponMessage:
        "You can fill in the required information here to exchange the coupon",
      couponCountry: "Your country",
      couponCompany: "Your company name",
      couponPosition: "Your title",
      couponUsername: "Name",
      couponMobile: "Phone number",
      couponEmail: "Email",
      couponCode: "Code",
      couponVerifyCode: "Verify Code",
      couponSubmit: "Submit",
      countryPlaceholder: "Please choose your region/country",
      companyPlaceholder: "Please fill in your company",
      positionPlaceholder: "Please fill in your position",
      usernamePlaceholder: "Please fill in your name",
      mobilePlaceholder: "Please fill in your phone number",
      emailPlaceholder: "Please fill in your Email",
      codeLeftPlaceholder: "Two first",
      codeCenterPlaceholder: "Two in the middle",
      codeRightPlaceholder: "Two after",
      verifyCodePlaceholder: "Verification code",

      text: "text",
      leadership: "Our Team",
      leadershipNav: "Our Team",
      leadershipTitle: "Our Team",
      leadershipSubTitle: "A happy，hard working and contagious team",

      servicePhone: "24-hour hotline: ",
      serviceContent: "7x24h, 365 Days",
      china: "(China Mainland)",
      international: "(International)",
      // 免费试用
      freeTitle: "Free Trial",
      freeHeader: "FREE TRIAL",
      freebannertitle:
        "GET ENTERPRISE GRADE CONNECTIVITY & APPLICATION ACCELERATION FOR YOUR GLOBAL ENTERPRISE",
      freeContentTitle: "Our Features",
      freeContentInfo: "We are a leading SD-WAN solution provider",
      freeContentMessage:
        "We build smart, stable, high speed, low latency WAN network to help Enterprise customers to focus on their core business",
      freePerformance: "High Performance",
      freeSecurity: "Strong Security",
      freeReliability: "High Reliability",
      freeRouting: "Smart Routing",
      freeEasy: "Easy To Use",
      freeReal: "Real-time Monitoring",
      freeAnalytics: "Data Analysis",
      freeFlexible: "Flexible Deployment",
      freeTryHeader: "Request Free Trial: ",
      freeFirstName: "First Name: ",
      freeLastName: "Last Name: ",
      freeEmail: "Email",
      freeEmailPlaceholder: "Please input your email account",
      freeFrist: "Please input your first name",
      freeLast: "Please input your last name",
      freeCompanyName: "Company Name: ",
      freeCompany: "Please input your company name",
      freeCountryName: "Region/Country:",
      freePhone: "Phone Number:",
      freeTel: "Please input your phone number",
      freeQuestion:
        "Do users encounter global application performance problems?",
      freeYes: "Yes",
      freeNo: "No",
      freeMore: "Tell us more",
      freeSubmit: "Submit",
      freeSuccess: "Your application has been submitted successfully!",
      freeFail: "Your application is unsuccessful, please reapply.",
      freeSubmitTitle: "An email has been sent your mailbox, please confirm!",
      freeOK: "OK",

      // 加入我们
      manage: "Expert Team",
      employee: "Company Staff",
      joinTitle: "Join Us",
      jobTitle: "Job List",
      jobEmail: "Welcome to delivery resume to:",

      // 客户端下载
      downloadHeader: "Client Download",
      downloadV1: "Latest Version Download",
      downloadV2: "V1.0 Download",
      downloadTitle: "OCEANBLUE CLOUD M100",
      downloadName: "M100 Client Download",
      downloadTip:
        "Universal client to enable all Oceanblue Cloud Network services",
      downloadTip2: "Great using experience on mobile and desktop devices",
      downloadTip3:
        "Enjoy network access on any of your devices easy and secure everywhere",
      downloadNow: "Download Now",
      downloadPoint: "Click to download",
      downloadSoon: "Open Soon...",
      downloadTip4: "Please click the “···”",
      downloadTip5: "then select another browser to open",
      downloadScreen: "Please view in the vertical screen",
      downnNetName: "NetTool Download",
      downnNetTip: "Can diagnose the network status of OBC service",
      kylin_uos: "KYLIN / UOS",
      ipsec_download: "If you need Ipsec, click to download",

      app_download: "Apps Download",
      app_download_m100: "M100 Client",
      app_new_name: "E-Connect",
      app_download_m100_tip:
        "The M100 Client supports VPN network access, and users can use multiple operating systems, including IOS, Android (E-Connect), Mac, Windows, Kirin/Unisys, and HarmonyOS",
      app_download_m100_tip2:
        "E-Connect Client supports VPN network access, and users can use the Android version.",
      app_download_go: "Go Download",
      app_sase: "SASE  Client",
      app_sase_tip:
        "The SASE Client supports zero-trust network access and is available for multiple operating systems including IOS, Android, Mac, and Windows",
      app_netool: "NetTool Client",
      app_netool_tip:
        "A Tool used to diagnose the condition of the OceanBlueCloud service",
      app_apple: "App Store Search 'M100' Download",
      download_title: "Download",
      download_ipsec: "Download (IPSec)",
      download_uos: "KYLIN/UOS",
      download_arm: "Download (Arm64)",
      download_x64: "Download (X64)",
      download_apple:
        "For Apple phones, please search 'M100' in the App Store to download.",
      download_development: "Development",
      download_apple_store: "Download (Apple)",
      download_apple_intel: "Download (Intel)",
      app_harmony:
        "For HarmonyOS NEXT (5.0.0) and Later Versions, Search for “M100” in the App Gallery to Download.",

      // 设备比较
      device: "Devices",
      comparison: "Comparison",
      R200_title: "Standard 1U Carrier Level  Device",
      R200_title2: "High Performance Device with Gigabits Interfaces,",
      R200_title3: "Powerful Network Device",
      R200_intro1: "RAM",
      R200_intro2: "Operational Ability",
      R200_intro3: "Forwarding Ability",
      R200_intro4: "Size",
      R200_intro5: "Interface",
      R200_intro6: "CISCO Standard Serial x1",
      R200_intro7: "Corporate Headquarter/Large Company Branch",
      R200_intro8: "Application Scenario",
      R200_intro9: "10-300 Users",
      R200_intro10: "Number of Users",
      R200_intro11: "1U Standard Rack",
      R200_intro12: "Installation",

      // D100设备
      D100_title: "Medium Level Network Device with High Performance",
      D100_title2: "Desktop Edge Connector,",
      D100_title3: "High Network Forwarding Ability,Stable and Reliable",
      D100_intro4: "Serial x1",
      D100_intro5: "Small and Medium-sized Company/Large Company Branch",
      D100_intro6: "10-50 Users",
      D100_intro7: "Desktop/Wall Hanging",

      // S200设备
      S200_title: "Intelligent Network Device with LTE Function",
      S200_title2: "High WIFI Ability,",
      S200_title3: "Support Global LTE as WAN Connection",
      S200_intro4: "SIM,Global LTE x1",
      S200_intro5: "Small Company Branch/Retail Store",
      S200_intro6: "5-30 Users",

      // S50设备
      S50_title: "Smart Size with Powerful Function",
      S50_title2: "Perfect Fits for Small and",
      S50_title3: "Medium Level Network Deployment",
      S50_intro4: "MicroUSB Power Supply x1",
      S50_intro5: "Small Company Branch/Retail Store",
      S50_intro6: "Less than 30 Users",

      // A55设备
      A55_title: "Personal Device with Global Data Roaming",
      A55_title2: "Global E-SIM, Multi-Color",
      A55_title3: "Smart Mobile Device for Global Business Man",
      A55_intro4: "Global LTE (Built in E-SIM)",
      A55_intro5: "Small and Medium-sized Company/Soho",
      A55_intro6: "Less than 5 Users",
      A55_intro7: "Desktop/Mobile",

      // 设备比较页

      comparison_title: "Compare",
      comparison_title2:
        "Application Scenario、Hardware、Network Performance、Installation methods,etc.",
      downloadApp: 'AppStore Search "M100"',

      // 合作销售
      partner_title: "Cooperate Apply",
      partner_banner: "Make Connection Easy, Make Business Agile.",
      partner_banner2: "Let’s create value for customer together.",
      partner_banner3:
        "Sales Partners are partners who work with OBC on the SDWAN market and sell OBC products, solutions, and services to end customers.",
      partner_type: "Type",
      partner_persnal: "Personal",
      partner_company: "Company",
      partner_name: "Name",
      partner_password: "Password",
      partner_passwordAgain: "Confirm password",
      partner_photoFront: "Front Photo of ID Card",
      partner_photoBack: "Back Photos of ID Card",
      partner_upload: "Upload",
      partner_companyEmail: "Company Email",
      partner_companyName: "Company Name",
      partner_companyType: "Type of Business Registration",
      partner_companyLicense: "Company License",
      partner_companyLicense2: "Business Registration Certificate",
      partner_companyOther: "Others",
      partner_companyPhoto: "Photo of Business Registration",
      partner_companyUsername: "Username",
      partner_companyPlaceholder: "Please fill in your company name",
    },
    m: en.menu,
    ep: en.enterprise,
    vn: en.vn,
    mb: en.mob,
    dv: en.dv,
  },
  ch: {
    language: {
      // 404页面
      notFoundMsg: "页面未找到",
      // header & footer
      headerServices: "服务",
      headerServicesOur: "概括",
      headerServicesDelivery: "云快递业务",
      headerServicesConnection: "云快线业务",
      headerServicesSd: "SD-WAN",
      headerServicesGlobal: "全球应用访问",
      headerSolutions: "解决方案",
      headerSolutionsOur: "概括",
      headerSolutionsSaas: "SaaS 加速",
      headerSolutionsCloud: "私有云服务",
      headerSolutionsMpls: "MPLS 混合",
      headerSolutionGlobal: "企业 OA/ERR 平台加速",
      headerAbout: "关于我们",
      aboutCompany: "关于公司",
      aboutTeam: "我们的团队",
      aboutInver: "投资人",
      headerLanguage: "English",
      headerLog: "登录",
      footerHome: "Home",
      footerService: "service",
      footerTech: "Technical Support",
      footerAbout: "about us",
      footerBack: "Back to top",

      // 主页文字
      mainWhatWan: "什么是 SD-WAN",
      mainWhatWanDefined: "软件定义的网络",
      mainWhatWanGlobal: "全球化的部署",
      mainWhatWanConnection: "提供企业专线链接",
      mainWhyWan: "为什么选择OBC",
      mainWhyWanHeight: "高性能的数据传输",
      mainWhyWanStrong: "高度的安全保护",
      mainWhyWanFlexible: "灵活的部署方式",
      mainCloud: "云快递业务",
      mainCloudSaas: "全球 SaaS 服务加速",
      mainCloudApp: "为应用数据提供保护",
      mainCloudSoho: "可弹性的部署方式",
      mainCloudRemote: "全方位实时监控",
      mainCloudConnection: "云快线业务",
      mainCloud1: "云快线业务",
      mainGlobal: "企业全球专线网络",
      mainData: "企业数据传输加速",
      mainSafeData: "安全的数据通道",
      mainSimple: "简便的部署方式",
      mainCloudBranch: "企业全球专线网络",
      mainCloudData: "企业数据传输加速",
      mainCloudSecured: "安全的数据通道",
      mainCloudEasy: "简易的部署方式",
      mainFeatures: "我们的特点",
      mainFeaturesWe: "我们是 SD-WAN 解决方案的领导者",
      mainFeaturesBuild:
        "我们建立先进、稳定、高速度、低延迟的WAN网络来帮助企业用户将注意力集中在他们的核心业务上。",
      mainPERFORMANCE: "高性能",
      mainPERFORMANCEDetail:
        "通过我们研发的FastIP技术，为不同地区间的节点提供高速的网络连接",
      mainSECURITY: "强安全",
      mainSECURITYDetail: "7*24小时保障的业务的可靠",
      mainRELIABILITY: "高可用",
      mainRELIABILITYDetail: "高强度的数据加密技术将保证数据传输过程中的私密性",
      mainSMART: "智能路由",
      mainSMARTDetail:
        "全球分布的中转网络，以及AI控制器组建起一个快速响应的自适应网络",
      mainEASY: "简单易用",
      mainEASYDetail: "便于使用的控制台",
      mainREAL: "实时监控",
      mainREALDetail: "实时掌握网络中各节点的状态，如有问题出现会及时发出通知",
      mainANALYTICS: "数据分析",
      mainANALYTICSDetail: "生成多种数据、报表和统计，以供企业IT人员分析使用",
      mainFlexible: "灵活部署",
      mainFlexibleDetail: "OBC产品可以被部署在任何有因特网的地方",
      mainGlobalEnterprise:
        "Global Enterprise Network with Connection as Service",
      mainGlobalWith:
        "With OBC’s Cloud connection service, it is easy and fast to deploy a global private network with branch offices in different locations.",
      mainGlobalImprove: "使用云应用快递服务提高应用效率",
      mainGlobalSaas:
        "使用了 OBC 云快递服务，企业云 SaaS 应用，如 office 365、Salesforce、sap 等的网络性能将至数倍以上。",
      mainWorldwide: "具有全球分布式的 SD-WAN 节点",
      mainSmart: "智能路由技术为高可用提供技术保障",
      mainShowMore: "展开以了解更多",
      mainClickShowMore: "点击以了解更多",

      // 服务
      serviceOur: "我们的产品",
      serviceWe: "进一步了解我们为您提供的产品",
      serviceCloud: "云快递业务",
      serviceSingle: "灵活的单端部署",
      serviceAcce: "加速多种 SaaS 应用",
      serviceSingleEnd: "提高特定国家或地区的访问速度",
      serviceUnderstand1: "understand more",
      serviceConnectAs: "云快线业务",
      serviceDouble: "双端或多端部署",
      serviceBuild: "核心网络创建全球私有网络",
      serviceConnectCustomer: "连接客户的云数据中心总部、分支机构",
      serviceConnectCustomer1: "以及虚拟机",
      serviceOBC: "OBC SD-WAN 解决方案",
      serviceHigh: "高性能",
      serviceStrong: "高度安全",
      serviceFlex: "部署灵活",
      serviceGlobalApp: "全球应用访问",
      serviceQuickly: "快速将您的内容分发至全球各地",
      serviceCustomer: "采用智能地域解析，将访问发布到离用户最近的地方",
      serviceSupports: "同时支持静态资源与动态数据的分布式部署",

      // 云快递
      deliveryCloud: "云快递业务",
      deliveryAccApp: "加速公有云应用，例如阿里邮箱、Office 365、Salesforce …",
      deliveryAccVM: "加速公有云虚拟机，例如阿里云ECS，亚马逊AWS，微软Azure …",
      deliveryAccService: "加速特定国家和地区的网络服务速度。",
      deliveryProblem: "我们产品解决的问题",
      deliveryHighNet: "在特定国家地区访问网络时出现的高延迟。",
      deliveryLowNet1: "从分支机构访问总部数据时的延迟。",
      deliveryLowNet2: "访问公有云应用时的迟缓响应。",
      deliveryAccNet: "在跨国网络下，网络速度提升",
      deliveryAccAll: "公有云应用访问速度提升",

      // 云快线
      connectionService: "云快线业务",
      connectionInternet: "Internet",
      connectionOBC: "OBC Overlay Cloud connection",
      connectionProvide:
        "Provide OBC overlay cloud connection between edge connectors",
      connectionHeadquarter:
        "Cloud connection between headquarter and Private Cloud nodes.",
      connectionBranches:
        "Cloud connection between branches and Public Cloud nodes.",
      connectionHeadquarterBranches:
        "Cloud connection between headquarter and branches.",
      connectionAchieve:
        "OBC云连接覆盖于边缘连接器之间，实现高速率低延迟的传输层第二或第三层的跨国连接",
      connectionPrivate: "在总部和私有云节点之间提供云连接。",
      connectionPublic: "在分部和公有云节点之间提供云连接。",
      connectionHead: "在总部和分部之间提供云连接。",

      // SD
      SDWhat: "为什么选择 ",
      SDWhat1: "OBC SD-WAN",
      SDWith:
        "随着企业宽带接入和互联网骨干网络容量的不断提高，在现有线路的基础上，SD-WAN提供了业界所寻求的低成本的网络连接方式。",
      SDTradition: "传统 MPLS 专线",
      SDInTradition:
        "在传统企业，电子邮件、文件分享、OA系统等应用都是通过集中部署方式实现的。",
      SDLimitations:
        "通常来说，在不同地区的分支机构通过MPLS专线连接到总部数据中心，其结构如下图所示：",
      SDInTradition2:
        "传统私有网络和MPLS专线伴随着许多限制：部署复杂、CAPEX/OPEX昂贵、且缺少灵活性。",
      SDThen: "SD-WAN 解决方案能突破以上的限制。",
      SDSDWan: "SD-WAN",
      SDEmploy:
        "SD-WAN是基于控制面/数据面隔离、集中管理以及其他的SDN概念上实现的技术。",
      SDEmploy2:
        "它有助于企业通过一个简单的操作中心在全球范围内快速部署WAN网络。",
      SDDoyou: "你是否曾经，或是否准备使用SD-WAN",
      SDPER1: "我们现在拥有SD-WAN应用",
      SDPER2: "我们在考虑使用SD-WAN",
      SDPER3: "我们不了解",
      SDPER4: "我们正在使用其他的WAN网络",
      SDPER5: "我们准备一年后使用SD-WAN",
      SDPER52: "deployment in the next 12 months",
      SDWhy: "为什么选择 OBC SD-WAN",
      SDWeBuild:
        "我们建立先进、稳定、高速度、低延迟的WAN网络来帮助企业用户将注意力集中在他们的核心业务上。",
      SDPlug: "即插即用的交付方式",
      SDPlug1: "所有配置全部由OBC后台控制器完成，无需现场调试",
      SDPlug2: "",
      SDPlug3: "",
      SDAgile: "智能简洁的部署",
      SDAgile1: "客户端零IT知识就可以使用",
      SDAgile2: "支持在第二三层的通信，对于客户现有的网络构造没有影响",
      SDAgile3: "",
      SDGlobal: "全球覆盖",
      SDGlobal1: "全球只要有因特网覆盖的地方，就可以部署OBC方案",
      SDOnDemand: "按需支付",
      SDOnDemand1: "为客户节省支出",
      SDOnDemand2: "软硬件均免费提供，客户只需要支付订购费用",
      SDOnDemand3: "",
      SDSecure: "安全的数据通道",
      SDSecure1: "OBC SD-WAN采用AES256加密技术全面保障客户的数据安全",
      SDHardware: "终身硬件保障",
      SDHardware1: "OBC硬件销售方保证超过99.9%的硬件可用性",
      SDHardware2: "承诺硬件终身免费更换",

      // 全球应用加速
      serviceGlobalBased:
        "基于OBC的全球分布节点，将您的网站发布至任意国家或地区，从而提升您的网站在全球的访问速度",
      serviceGlobalSupporting:
        "同时支持静态资源与动态数据接口的加速，比CDN更胜一筹。",
      serviceGlobalInternet: "使用服务后在不同国家之间做跨国访问时网速可实现",
      serviceGlobalHaundredfold: "百倍增长",
      serviceGlobalEffect: "效果实例",
      serviceGlobalUSA: "美国",
      serviceGlobalUSAspeed1: "提速前网速: 40 K/S",
      serviceGlobalUSAspeed2: "提速后网速: 13 M/S",
      serviceGlobalJapan: "日本",
      serviceGlobalJapanspeed1: "提速前网速: 50 K/S",
      serviceGlobalJapanspeed2: "提速后网速: 20 M/S",
      serviceGlobalIndia: "印度",
      serviceGlobalIndiaspeed1: "提速前网速: 20 K/S",
      serviceGlobalIndiaspeed2: "提速后网速: 17 M/S",

      // 解决方案
      solutionOur: "我们的解决方案",
      solutionOBC: "OBC SD-WAN 为企业网络连接",
      solutionOBC1: "提供了以下专业解决方案",
      solutionOffice: "基于提升OFFICE365",
      solutionOffice1: "性能的OBC云快递解决方案",
      solutionGlobal: "基于全球私有网络的OBC云快线解决方案",
      solutionMPLS: "从MPLS到OBC混合网络的演化之路",
      solutionGlobalApp: "使用全球应用部署对企业OA/ERP平台的加速",

      // 解决方案1
      solution1Office: "OBC云快递业务改进",
      solution1Office1: "Office 365性能",
      solution1Cloud: "通过OBC的云快递服务，能大大改善Office 365操作流畅度。",
      solution1Cloud1: "网络架构部署如下图所示：",
      solution1Application: "OBC云快递业务",
      solution1Application1: "提升应用体验",
      solution1Edge1:
        "每个分支机构都部署了OBC边缘连接器，来用于连接OBC云快递服务。",
      solution1Edge2: "OBC云快递网络加速了数据传输到Office 365云服务器的进程。",
      solution1Edge3: "OBC云快递网络利用低延迟网络技术显著提升了应用体验。",

      // 解决方案2
      solution2Global: "基于全球私有网络的",
      solution2Global1: "OBC云快线业务解决方案",
      solution2OBCConnection:
        "OBC云快线提供快速、简便的部署全球私有网络的解决方案。",
      solution2OBCNetwork: "以下为网络部署拓扑图",
      solution2OBCCloud:
        "OBC 云快线采用 AES-256 强加密方式, 保护用户数据在世界各地传输。并且，FastIP 加速显著地提高了通信性能。 ",
      solution2OBCSDWAN:
        " 通过OBC SD-WAN网络部署后，位于不同地区的分支机构可以通过虚拟专线L2或L3网络进行互相访问。",
      solution2With:
        "通过OBC云快线服务，企业的运营成本和资本性支出将会明显地下降，且远低于MPLS专线。",
      solution2Bandwidth: "宽带费用",

      // 解决方案3
      solution3MPLS: "从MPLS到OBC混合网络的演化之路",
      solution3Connection:
        "OBC云快线构建了一个快速、简便的部署全球私有网络的解决方案。",
      solution3Network: "网络部署的拓补结构如下：",
      solution3AsAbove:
        "如上图所示，OBC边缘控制器将MPLS和互联网连接进行了结合。在一般情况下，MPLS连接处于活跃状态，因特网连接处于备用状态。一旦MPLS出现异常，OBC边缘控制器将切换使用因特网连接。",
      solution3TheMpls: "同时，MPLS 连接将一直被监控，直至其恢复正常工作。",
      solution3Once:
        "Once the MPLS breaks down, the OBC edge switch the data to the Internet links. And the MPLS link will be kept monitored until it recovers.",
      solution3ImageShow:
        "The image above shows the hybrid link fail-over case.",

      // 解决方案4
      solution4Using: "使用全球应用部署对企业OA/ERP平台的加速",
      solution4Enterprise:
        "当企业的OA/ERP平台接入到OBC的全球应用部署方案后，在世界各地均可快速地访问企业数据资源。",
      solution4Noneed:
        "企业无需部署任何硬件设备，全球员工只需访问OBC全球应用部署提供的域名，即可实现静态资源与动态数据的全面加速。",
      solution4Application: "应用概览",
      solution4Before: "加速前网速范围10-20Kbps，加速后可达10-20Mbps",

      // 关于我们
      aboutOcean: "OCEANBLUE CLOUD",
      aboutMake: "使连接变得容易，使业务敏捷 ",
      aboutWhoWeAre: "我们是谁",
      aboutAboutUs: "关于我们",
      aboutWeAre: "我们是OceanBlue Cloud，领先的SD-WAN供应商。",
      aboutFor:
        "几十年来企业通过部署DDN, Frame Relay和MPLS等广域网技术保证其商业数据的高质量转发。近年来随着云架构DC和混合架构DC的广泛应用，同时大数据和实时商业数据传输的需求越来越多，传统的专线连接技术已经不能满足客户快速部署商业应用和连接的需求。",
      aboutOceanBlue:
        "Oceanblue Cloud(深圳睿网云联科技有限公司)认为远距离和实高质量的实时数据传输需求不应该成为驱动商业快速反应的瓶颈，OBC通过自有的先进Fastip技术可以帮助企业客户实现广域连接的快速部署，不管是通过Internet还是MPLS,客户都能获得超高速的高质量数据传输服务。",
      aboutWithOur:
        "同时OBC致力于通过人工智能重新定义广域网网络连接，通过先进的分布式云端控制器实时感知网络健康状态并调度流量，实现了SLA的可视化。",
      aboutTianCheng: "Tiancheng Zhang",
      aboutFounder: "Founder & CEO",
      aboutTianChengExperience:
        "15+ years in ICT industry, CCIE, System Analyst. He has worked as senior positions in Ericsson / Huawei / Emirates Telecom and other top companies. He has deep understanding in enterprise and telecom field with excellent execution and willpower.",
      aboutYaoHua: "Yaohua Liu",
      aboutCo1: "Co-Founder",
      aboutYaoHuaExperience:
        "15+ years of experience in R&D, Senior architect, he had worked in Ericsson / Samsung / Nortel. He has a profound understanding in the distributed system and wealth of experience with product life-cycle management quality Control.",
      aboutLei: "Larry Wang",
      aboutCo2: "Co-Founder",
      aboutLeiExperience:
        "10+ years in the bottom layer of network technology development, He has a deep understanding network development technology. He has excellent understanding of the whole process from development to application.",
      aboutLocations: "公司地址",

      aboutSZ: "中国 · 深圳",
      aboutSZemail: "contact@oceanbluecloud.com",
      aboutSZaddr1: "广东省深圳市南山区西丽街道TCL国际E城E2栋A栋601",

      aboutHK: "中国 · 香港",
      aboutHKemail: "contact@oceanbluecloud.com",
      aboutHKaddr1: "香港旺角廣東道998號高明商業大廈15B",

      aboutDubai: "迪拜阿拉伯联合酋长国",
      aboutDubaiEmail: "contact@oceanbluecloud.com",
      aboutDubaiAddr1:
        "Unit No 68, Ground floor, Bldg. No.17 Dubai Internet City, Dubai UAE PO BOX 336810",
      aboutDubaiAddr4: "",

      aboutSingapore: "新加坡共和国",
      aboutSingaporeEmail: "contact@oceanbluecloud.com",
      aboutSingaporeAddr1: "#10-09 PAYA LEBAR SQUARE SINGAPORE,",
      aboutSingaporeAddr2: "",
      aboutSingaporeAddr3: "",
      aboutSingaporeAddr4: "Tel:+0065 92343288",

      aboutSuzhou: "中国 · 苏州",
      aboutSuzhouEmail: "contact@oceanbluecloud.com",
      aboutSuzhouAddr1: "苏州工业园区新平街388号腾飞科技园21幢5层04室",
      aboutSuzhouAddr2: "",
      aboutSuzhouAddr3: "电话：0512-88982707",
      aboutSuzhouAddr4: "",

      aboutShanghai: "中国 · 上海",
      aboutShanghaiEmail: "contact@oceanbluecloud.com",
      aboutShanghaiAddr1: "上海市浦东新区耀体路308号晶耀前滩T2号楼813",
      aboutShanghaiAddr2: "",
      aboutShanghaiAddr3: "电话：021-31836988",
      aboutShanghaiAddr4: "",

      aboutJiNan: "中国 · 济南",
      aboutJiNanEmail: "contact@oceanbluecloud.com",
      aboutJiNanAddr1: "山东省济南市解放东路6-17号CBD中央广场D座802室",
      aboutJiNanAddr2: "",
      aboutJiNanAddr3: "",
      aboutJiNanAddr4: "",

      aboutUSA: "美国 · 加利福尼亚",
      aboutUSAEmail: "contact@oceanbluecloud.com",
      aboutUSAAddr1:
        "1360 Valley Vista Dr, Suite 125, Diamond Bar, CA 91765, USA",
      aboutUSAAddr2: "",
      aboutUSAAddr3: "",
      aboutUSAAddr4: "",

      aboutFlb: "菲律宾",
      aboutFlbEmail: "contact@oceanbluecloud.com",
      aboutFlbAddr1:
        "18th Floor, ORE Central, 31st Street, Taguig, Metro Manila, Philippines",
      aboutFlbAddr2: "",
      aboutFlbAddr3: "",
      aboutFlbAddr4: "",

      aboutBJ: "中国 · 北京",
      aboutBJEmail: "contact@oceanbluecloud.com",
      aboutBJAddr1: "北京市朝阳区朝外大街26号朝外MENB座708",
      aboutBJAddr2: "",
      aboutBJAddr3: "",
      aboutBJAddr4: "",

      aboutBX: "巴西",
      aboutBXEmail: "contact@oceanbluecloud.com",
      aboutBXAddr1:
        "Av dos Autonomistas4900, galpão C 03.0.0, km 18, Osasco-SP Brasil CEP: 06194-060",
      aboutBXAddr2: "",
      aboutBXAddr3: "",
      aboutBXAddr4: "",

      serviceUs: "联系我们",
      serviceEmail: "邮箱",
      serviceTime: "服务时间",
      serviceTime2: "周一至周五 09:30-18:30,国家法定节假日除外",
      serviceTel: "客服热线",
      serviceTime3: "服务时间",
      serviceWeChat: "扫码关注企业微信服务号",
      // 活动页
      yunQiComputingTitle: "云栖大会·OCEANBLUE CLOUD",
      yunQiComputingContent1:
        "云栖大会已经成为全球云计算TOP级峰会，汇聚DT时代最强大脑，描绘云计算发展趋势和蓝图，展现云计算、大数据、人工智能蓬勃发展的技术生态全景。2017云栖大会将于10月继续在中国杭州云栖小镇举办，打造年度最精彩的云计算盛会。",
      yunQiComputingContent2:
        "睿网云联作为领先的SD-WAN供应商，致力于通过人工智能重新定义广域网网络连接，通过先进的分布式云端控制器实时感知网络健康状态并调度流量，实现了SLA的可视化。通过自有的先进Fastip技术可以帮助企业客户实现广域连接的快速部署，不管是通过Internet还是MPLS，客户都能获得超高速的高质量数据传输服务。",
      yunQiDetailsTitle: "/ 展会详情",
      yunQiDetailsDuring:
        "大会期间将为大家展示睿网云联的各种产品及令人惊喜的服务，并支持现场体验使用。",
      yunQiDetailsKeynote:
        "主题演讲: Make business agile by deploying cloud based connection",
      yunQiDetailsFounder: "2017年10月13日  Founder & CEO -Alexann Zhang",
      yunQiDetailsSome:
        "大会期间还将送出多份为期一年的服务体验资格给现场用户。",
      yunQiDetailsMore: "更多精彩内容请持续关注。",
      yunQiLocationTitle: "Oct.11-14, 2017",
      yunQiLocationContent:
        "会场地址：杭州市西湖区河山路1号云栖小镇国际会展中心D3-301",
      yunQiExhibitionTitle: "云栖大会·展会福利",
      yunQiExhibitionContent1: "为期一年的服务",
      yunQiExhibitionContent2: "提供给您免费使用体验",
      yunQiExhibitionContent3: "",
      yunQiExhibitionContent4: "睿网云联致力于优化每一位用户的网络使用体验。",
      yunQiExhibitionContent5:
        "大会期间为您准备了我们的产品及服务供您尽情的使用体验，获得体验券的用户请在指定兑换日期内点击下方兑换按钮，进行资料完善便可领取使用。",
      yunQiExhibitionOk: "立即兑换",

      // 投资人
      investorTitle: "我们的投资人",

      // 体验券
      yunQiOcean: "睿网云联",
      yunQiOceanCreate: "打造智慧网络新风向",
      couponTitle: "业务体验领取",
      couponMessage: "你可以在此填写所需资料以进行线上领取体验",
      couponCountry: "所在国家",
      couponCompany: "公司名称",
      couponPosition: "所在职位",
      couponUsername: "联系人",
      couponMobile: "联系方式",
      couponEmail: "邮箱",
      couponCode: "体验券号码",
      couponVerifyCode: "验证码",
      couponSubmit: "提交",
      countryPlaceholder: "请选择所在区域/国家",
      companyPlaceholder: "请填写您所在的公司",
      positionPlaceholder: "请填写您所在的职位",
      usernamePlaceholder: "请填写您的姓名",
      mobilePlaceholder: "请填写您的联系电话",
      emailPlaceholder: "请填写您的邮箱地址",
      codeLeftPlaceholder: "号码前两位",
      codeCenterPlaceholder: "号码中间两位",
      codeRightPlaceholder: "号码后两位",
      verifyCodePlaceholder: "请输入右侧验证码",

      text: "text",
      leadership: "Our Team",
      leadershipNav: "Our Team",
      leadershipTitle: "我们的团队",
      leadershipSubTitle: " 这就是我们，欢乐的团队，工作努力积极，富有感染力。",

      servicePhone: "24小时全国热线: ",
      serviceContent: "7x24h, 365天全年无休",
      china: "(中国大陆)",
      international: "(港澳台、海外)",
      freeTitle: "免费试用",
      freeHeader: "免费试用",
      freebannertitle: "为您的全球企业获得企业级连接性和应用程序加速",
      freeContentTitle: "产品特性",
      freeContentInfo: "我们是领先的SD-WAN解决方案提供商。",
      freeContentMessage:
        "我们构建智能、稳定、高速、低延迟的广域网，帮助企业客户专注于核心业务。",
      freePerformance: "高性能",
      freeSecurity: "高安全性",
      freeReliability: "高可靠性",
      freeRouting: "智能路由",
      freeEasy: "简单易用",
      freeReal: "实时监控",
      freeAnalytics: "数据分析",
      freeFlexible: "部署灵活",
      freeTryHeader: "免费试用: ",
      freeFirstName: "名: ",
      freeLastName: "姓: ",
      freeFrist: "名",
      freeLast: "姓",
      freeEmail: "Email",
      freeSuccess: "您的申请已提交成功!",
      freeFail: "您的申请未成功,请您重新申请.",
      freeEmailPlaceholder: "请输入您的Email账号",
      freeCompanyName: "公司名称: ",
      freeCompany: "请输入公司名称",
      freeCountryName: "所在区域/国家:",
      freePhone: "电话:",
      freeTel: "请输入您的电话号码",
      freeQuestion: "用户是否遇到全球性的应用程序性能问题?",
      freeYes: "是",
      freeNo: "否",
      freeMore: "告诉我更多",
      freeSubmit: "提交",
      freeSubmitTitle:
        "OceanBlue Cloud向您的邮箱发送了一封邮件,请登录邮箱确认!",
      freeOK: "确定",

      // 加入我们
      manage: "专家团队",
      employee: "公司员工",
      joinTitle: "加入我们",
      jobTitle: "职位列表",
      jobEmail: "欢迎投递简历至:",

      // 客户端下载
      downloadHeader: "客户端下载",
      downloadV1: "最新版 下载",
      downloadV2: "V1.0 下载",
      downloadTitle: "OCEANBLUE CLOUD M100",
      downloadName: "M100客户端下载",
      downloadTip: "可使用欧深网络所有服务的通用客户端",
      downloadTip2: "可支持所有主流移动及桌面设备",
      downloadTip3: "可通过任意设备享受安全便捷的网络接入",
      downloadNow: "立刻下载",
      downloadPoint: "点击下载",
      downloadSoon: "即将开放...",
      downloadTip4: "请点击右上角“···”",
      downloadTip5: "选择在浏览器中打开",
      downloadScreen: "请在竖屏下浏览",
      downnNetName: "NetTool下载",
      downnNetTip: "可诊断欧深网络服务的网络状况",
      kylin_uos: "麒麟/统信",
      ipsec_download: "如需Ipsec,点击下载",

      app_download: "应用下载",
      app_download_m100: "M100客户端",
      app_new_name: "云安通",
      app_download_m100_tip:
        "M100客户端支持VPN网络访问， 用户可使用多种操作系统，包括IOS, 安卓, Mac, Windows, 麒麟/统信, HarmonyOS",
      app_download_m100_tip2:
        "云安通客户端支持VPN网络访问， 用户可使用安卓版本",
      app_download_go: "去下载",
      app_sase: "SASE客户端",
      app_sase_tip:
        "SASE客户端支持零信任网络访问，用户可使用多种操作系统，包括IOS, 安卓, Mac, Windows",
      app_netool: "NetTool客户端",
      app_netool_tip: "用于诊断欧深网路服务状况的工具。",
      app_apple: "App Store 搜索 '睿连终端M100' 下载",
      download_title: "下载",
      download_ipsec: "下载 (IPSec)",
      download_uos: "麒麟/统信",
      download_arm: "下载 (Arm64)",
      download_x64: "下载 (X64)",
      download_apple: "苹果手机请在App Store搜索 '睿连终端M100' 下载",
      download_development: "研发中",
      download_apple_store: "下载 (Apple)",
      download_apple_intel: "下载 (Intel)",
      app_harmony: "鸿蒙NEXT(5.0.0)及以上版本通过应用市场搜索“M100”下载",

      // 设备比较
      device: "硬件设备",
      comparison: "机型比较",

      // R200设备
      R200_title: "标准1U的运营商级设备",
      R200_title2: "超高转发性能",
      R200_title3: "极速千兆网口  稳定组网",
      R200_intro1: "内存",
      R200_intro2: "业务能力",
      R200_intro3: "转发能力",
      R200_intro4: "设备尺寸",
      R200_intro5: "接口",
      R200_intro6: "思科标准串口 x1",
      R200_intro7: "企业总部 / 大型企业分支机构",
      R200_intro8: "应用场景",
      R200_intro9: "10-300人",
      R200_intro10: "建议使用人数",
      R200_intro11: "1U 标准机架安装",
      R200_intro12: "安装方式",

      // D100设备
      D100_title: "高性能中小型组网设备",
      D100_title2: "桌面型边缘连接器",
      D100_title3: "高转发性能，稳定可靠",
      D100_intro4: "串口 x1",
      D100_intro5: "中小型企业 / 大型企业分支机构",
      D100_intro6: "10-50人",
      D100_intro7: "桌面/墙挂",

      // S200设备
      S200_title: "具备LTE功能的组网终端",
      S200_title2: "高性能WIFI",
      S200_title3: "支持全球LTE作为WAN接入",
      S200_intro4: "SIM/全球 LTE x1",
      S200_intro5: "小型企业分支 / 零售门店",
      S200_intro6: "5-30人",

      // S50设备
      S50_title: "精巧体积下的澎湃性能",
      S50_title2: "完美适配小型组网场景的",
      S50_title3: "智能设备",
      S50_intro4: "MicroUSB 电源接口 x1",
      S50_intro5: "小型企业分支 / 零售门店",
      S50_intro6: "小于30人",

      // A55设备
      A55_title: "全球漫游的个人智能设备",
      A55_title2: "全球E-SIM, 多色可选",
      A55_title3: "全球商旅人士的便携智能设备",
      A55_intro4: "全球漫游LTE (内置E-SIM)",
      A55_intro5: "中小型企业/连锁机构或SoHo",
      A55_intro6: "小于5人",
      A55_intro7: "桌面/手持",

      // 设备比较页

      comparison_title: "机型比较",
      comparison_title2: "应用场景、硬件参数、性能参数、安装方式等介绍",
      downloadApp: 'AppStore 搜索 "睿连终端M100"',

      // 合作销售
      partner_title: "合作申请",
      partner_banner: "Make Connection Easy, Make Business Agile.",
      partner_banner2: "让我们一起实现客户价值",
      partner_banner3: "销售合作伙伴在行业或区域内从事OBC产品和解决方案销售.",
      partner_type: "合作类型",
      partner_persnal: "个人",
      partner_company: "企业",
      partner_name: "姓名",
      partner_password: "密码",
      partner_passwordAgain: "确认密码",
      partner_photoFront: "身份证正面照片",
      partner_photoBack: "身份证反面照片",
      partner_upload: "上传",
      partner_companyEmail: "企业邮箱",
      partner_companyName: "企业名称",
      partner_companyType: "营业登记类型",
      partner_companyLicense: "营业执照",
      partner_companyLicense2: "商业登记证",
      partner_companyOther: "其他",
      partner_companyPhoto: "营业登记图片",
      partner_companyUsername: "联系人",
      partner_companyPlaceholder: "请输入企业名称",
    },
    m: ch.menu,
    ep: ch.enterprise,
    vn: ch.vn,
    mb: ch.mob,
    dv: ch.dv,
  },
};
// Create VueI18n instance with options
export default new VueI18n({
  locale: "en", // set locale
  messages, // set locale messages
});



// WEBPACK FOOTER //
// ./src/i18n/index.js